export default {
  SET_USER_DATA(state, payload) {
    const account = payload?.account ?? {};

    state.userInfo = {
      ...(payload ?? {}),
      account: {
        ...account,
        id: account.id ?? null,
        token: account.token ?? '',
      },
    };
  },
  SET_CHANGE_PASSWORD_REQUIREMENT(state, payload) {
    state.shouldChangePassword = payload;
  },
  SET_PROMOTER_ACCESSES(state, payload) {
    state.promoterAccesses = payload || [];
  },
};
